'use strict';

var Common = require('../../opsperfect-common');

module.exports = Common;
